var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewBooking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.65 58.33h3.69a2.62 2.62 0 0 0 2.62-2.62V28.254c0-1.308.94-2.5 2.241-2.631a2.501 2.501 0 0 1 2.759 2.487v27.6a7.62 7.62 0 0 1-7.62 7.62h-3.69a2.5 2.5 0 1 1 0-5zM8.66 63.33a7.62 7.62 0 0 1-7.62-7.62V10.66a7.62 7.62 0 0 1 7.62-7.62h4.57A2.492 2.492 0 0 1 15.71.67c1.34 0 2.42 1.05 2.49 2.37.01 0 .01.09.01.09v4.91a2.508 2.508 0 0 1-2.5 2.36 2.49 2.49 0 0 1-2.48-2.36H8.66a2.62 2.62 0 0 0-2.62 2.62v5.95h51.92v-5.95a2.62 2.62 0 0 0-2.62-2.62h-4.57a2.49 2.49 0 0 1-2.48 2.36c-1.34 0-2.42-1.05-2.49-2.36H34.49c-.08 1.31-1.16 2.36-2.49 2.36s-2.41-1.05-2.49-2.36H24.9c-1.272 0-2.447-.869-2.652-2.124-.262-1.6 1.092-2.876 2.613-2.876h4.65c.08-1.32 1.16-2.37 2.49-2.37s2.41 1.05 2.49 2.37H45.8A2.494 2.494 0 0 1 48.29.67c1.33 0 2.41 1.05 2.48 2.37h4.57a7.62 7.62 0 0 1 7.62 7.62v7.51c0 1.9-1.54 3.44-3.44 3.44H6.04v34.1a2.62 2.62 0 0 0 2.62 2.62h3.69a2.5 2.5 0 1 1 0 5z",
    fill: "#3c0000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.001 29.575c-9.306 0-16.876 7.571-16.876 16.875 0 9.306 7.571 16.876 16.876 16.876s16.875-7.571 16.875-16.876c0-9.304-7.571-16.875-16.875-16.875zm0 29.227c-6.811 0-12.351-5.54-12.351-12.351 0-6.81 5.54-12.35 12.351-12.35 6.81 0 12.35 5.54 12.35 12.35-.001 6.81-5.541 12.351-12.35 12.351z",
    fill: "#3c0000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.647 40.074a2.6 2.6 0 0 0-1.844.744l-5.76 5.76-1.886-1.886c-.977-.975-2.685-.973-3.659 0-1.002 1.001-.997 2.659 0 3.659l3.732 3.73a2.565 2.565 0 0 0 1.829.758c.716 0 1.382-.271 1.872-.765l7.562-7.563c1.005-1.005 1.003-2.692 0-3.692a2.601 2.601 0 0 0-1.846-.745z",
    fill: "#3c0000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBooking);
export default __webpack_public_path__ + "static/media/view-booking.9df615c332281e66118bf381d238ff65.svg";
export { ForwardRef as ReactComponent };